/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import NextdoorWarningModal from 'app/components/common/NextdoorWarningModal.jsx';

let isConnecting = false;

let ConnectMixin = {
    connectService: function(e, handle) {
		let serviceId = parseInt(e.currentTarget.dataset.serviceid, 10),
            subType = parseInt(e.currentTarget.dataset.subtype, 10),
            directConnect = false,
			url = "/remote/begin?psID=:psId&state=:state&final=:final",
			date = new Date(),
			state = '',
			constants = this.props.app.config.constants,
			finalUrl = '',
            routeId = 0,
            tracking = true;

        if (isConnecting) {
            return;
        }

        if (e.currentTarget.dataset.direct === "true") {
            directConnect = true;
        }

        if (isNaN(serviceId) && this.state !== undefined && this.state.serviceId !== undefined) {
            serviceId = this.state.serviceId;
        }

        state = ['POST', serviceId, date.getTime()].join("_")

        if (e.currentTarget.dataset.servicetype) {
            url = url.replace("psID=", e.currentTarget.dataset.servicetype + "=");
            state = ['GENERIC', serviceId, date.getTime()].join("_");
            tracking = false;
        }

        if (this.props.routeId) {
            state = ['POST', serviceId, this.props.routeId, date.getTime()].join("_");
        }

		if (directConnect && this.props.user.perms.resources.outputsAvailable == 0) {
			this.props.showUpgradeModal(this.props.closeAllModals, 'socials', null, 'social_modal');
			return;
		}

		// TODO: Make type checking generic when the shit settles.
		// if (serviceId == constants.POST_SVC_PINTEREST) {
		// 	if (this.props.user.perms.resources.pinterestOutput === 0) {
        //         this.props.closeAllModals();
		// 		this.props.showUpgradeModal(this.props.closeAllModals, 'pinterest', null, 'social_modal');
		// 		return;
		// 	}
		// }

        if (directConnect && serviceId === constants.POST_SVC_FACEBOOK) {
            subType = constants.FB_PAGE;
        }

		if (serviceId == constants.POST_SVC_FEED) {
			if (this.props.user.perms.resources.feedOutput === 0) {
                this.props.showUpgradeModal(this.props.closeAllModals, 'feedOutput', null, 'social_modal');
				return;
			}
		}

		if (this.props.isFreeUser()) {
			// if outputsUsed isn't set this may be a new user onboarding (or a user with 0 feeds & socials)
			// check the in-state route instead
			if (this.props.user.perms.resources.outputsUsed) {
				if (directConnect && this.props.user.perms.resources.outputsUsed.indexOf(serviceId) !== -1) {
                    this.props.showUpgradeModal(this.props.closeAllModals, 'unique', null, 'social_modal');
					return;
				}
			}
		}

		if (parseInt(serviceId, 10) === constants.POST_SVC_FEED) {
            if (!directConnect && _.findWhere(this.props.socials.counts, {type: serviceId}) !== undefined) {
                this.props.switchView('chooseAcct', serviceId);
            } else {
                this.props.switchView('createfeed');
            }

			return;
		} else if (parseInt(serviceId, 10) === constants.POST_SVC_BLUESKY && directConnect) {
            this.props.switchView("blueskycreds");
            return;
        } else {
			if (state.match(/^POST/) && !directConnect && _.findWhere(this.props.socials.counts, {type: serviceId}) !== undefined) {
				this.props.switchView('chooseAcct', serviceId);
                return;
			}
		}

        if (subType) {
            url += "&ast=" + subType;
        }

        if (this.state !== undefined && this.state !== null && this.state.mastodonHandle !== undefined) {
            url += "&mastodonHandle=" + encodeURIComponent(this.state.mastodonHandle);
        }

		if (this.props.redirect && this.props.redirect !== '') {
			finalUrl = window.encodeURIComponent(this.props.redirect);
		} else {
			finalUrl = window.encodeURIComponent(window.location.href);
		}

        if (tracking) {
    		if (dataLayer && this.props.onboarding !== null) {
    			dataLayer.push({
    				'event': 'onboarding-social-select',
    				'social-network': ConstantMixin.getPostServiceNameByCode(serviceId)
    			});
    		}
    		if (mixpanel !== undefined && this.props.onboarding !== null) {
    			mixpanel.track("Choose social", {
    				'network': ConstantMixin.getPostServiceNameByCode(serviceId)
    			});
    		}
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Choose Social',
                    event_data: {
                        'network': ConstantMixin.getPostServiceNameByCode(serviceId)
                    }
                })
            }
        }

		url = url.replace(':psId', serviceId);
		url = url.replace(':state', state);
		url = url.replace(':final', finalUrl);
        // remove the directive to open the social select modal on return
        url = url.replace('?add=true', '');

        if (serviceId == constants.POST_SVC_NEXTDOOR) {
            let WarningModal = NextdoorWarningModal;

            const cancelAction = (e) => {
                if (this.state && this.state.isConnecting !== undefined) {
                    this.setState({
                        isConnecting: false
                    });
                }
                e.preventDefault();
                // le sigh... gotta special case this for the new posting tool to properly
                // reset the socials
                if (this.props.context !== undefined && this.props.context === 'posting') {
                    this.props.filterStore('socials', ['activeFlag'], 1);
                }
                this.props.closeAllModals();
            }
            let modal = (
                <WarningModal
                    closeAction={(e) => {
                        cancelAction(e);
                    }}
                    cancelAction={(e) => {
                        cancelAction(e);
                    }}
                    confirmAction={(e) => {
                        e.preventDefault();
                        isConnecting = true;
                        window.location.assign(url);
                    }}/>
            );
            this.props.closeAllModals();
            this.props.addModal(modal);
        } else {
            isConnecting = true;
            window.location.assign(url);
        }


	}
};

export default ConnectMixin;
